export default __webpack_public_path__ + "static/media/ernest-mena-logo.f51f4818.svg";